import { useWorkingLocations as usePackageWorkingLocations } from '@gettactic/hooks';
import { ScheduleParamsAll } from '@gettactic/api';

export type QueryOptions =
  | { keepPreviousData?: boolean; enabled?: boolean }
  | undefined;

export function useWorkingLocations(
  filters: ScheduleParamsAll,
  options: QueryOptions = { keepPreviousData: true, enabled: true },
) {
  // Pass local API client through the custom hook API
  return usePackageWorkingLocations(filters, options);
}
